import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=1a3217fa&scoped=true&"
import script from "./StatisticCard.vue?vue&type=script&lang=ts&"
export * from "./StatisticCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticCard.vue?vue&type=style&index=0&id=1a3217fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3217fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
